import { render, staticRenderFns } from "./staff_card2.vue?vue&type=template&id=7c67db24&scoped=true&"
import script from "./staff_card2.vue?vue&type=script&lang=js&"
export * from "./staff_card2.vue?vue&type=script&lang=js&"
import style0 from "./staff_card2.vue?vue&type=style&index=0&id=7c67db24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c67db24",
  null
  
)

export default component.exports